<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Cont. Fee</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="container_fee" type="text" placeholder="Container fee" :class="{ 'is-danger': errors.container_fee }">
                    <span class="icon is-left">
                        <i class="fas fa-ship"></i>
                    </span>
                    <p v-if="errors.container_fee" class="help is-danger">{{ errors.container_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            container_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.container_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'container_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/ContainerFeeInput.vue